export * from './micro-electric-bike-plate-number-format-strategy';
export * from './micro-electric-bike-plate-number-strategy';
